// src/services/blog/GetPublicBlogs.ts
import axios, { AxiosResponse } from "axios";
import getApiBaseUrl from "../GetServer";

export interface Blog {
  id: number;
  date: string;
  title: string;
  description: string;
  imageName: string;
  seo: string;
  status: number;
}

export interface PaginatedBlogsResponse {
  status: number;
  message: string;
  data: Blog[];
  currentPage: number;
  totalPages: number;
  totalCount: number;
  hasNext: boolean;
}

export interface PaginationParams {
  page: number;
  pageSize: number;
  language: string;
}

export const GetPublicBlogs = async (
  params: PaginationParams
): Promise<PaginatedBlogsResponse> => {
  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}blog/get-public-blogs`;

    const response: AxiosResponse<PaginatedBlogsResponse> = await axios.post(
      endpoint,
      params,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.status !== 200) {
      throw new Error(response.data.message);
    }

    return response.data;
  } catch (error) {
    console.error("Error al obtener blogs públicos:", error);
    throw new Error(
      "No se pudieron cargar las entradas del blog. Inténtalo de nuevo más tarde."
    );
  }
};
